import { useState, useRef } from "react";
import { CRUDPage } from "./AdminServices";
import { TextInput, Toggle } from "./ui";
import { api, apiErr } from "./api";
import { UploadCloud, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { API_BASE } from "@/lib/env";

export default function AdminPortfolio() {
  return (
    <CRUDPage
      endpoint="portfolio"
      title="Portföy"
      Form={PortfolioForm}
      columns={[
        { k: "title", l: "Başlık" },
        { k: "category", l: "Kategori" },
        { k: "image", l: "Görsel" },
      ]}
      emptyModel={{ title: "", category: "", image: "", storage_path: null, order: 0, active: true }}
      testid="portfolio"
      customRender={(k, it) => {
        if (k === "image") {
          return <img src={resolveImg(it)} alt="" className="w-12 h-12 object-cover border border-white/10" />;
        }
        return null;
      }}
    />
  );
}

function resolveImg(it) {
  if (it.storage_path) return `${API_BASE}/public/media/${it.storage_path}`;
  return it.image;
}

function PortfolioForm({ v, set }) {
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();

  const upload = async (f) => {
    if (!f) return;
    setUploading(true);
    try {
      const fd = new FormData(); fd.append("file", f);
      const { data } = await api.post("/admin/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
      set("storage_path", data.storage_path);
      set("image", `${API_BASE}/public/media/${data.storage_path}`);
      toast.success("Görsel yüklendi");
    } catch (e) { toast.error(apiErr(e)); }
    finally { setUploading(false); }
  };

  const preview = v.storage_path ? `${API_BASE}/public/media/${v.storage_path}` : v.image;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TextInput label="Başlık (varsayılan / TR)" value={v.title || ""} onChange={(e) => set("title", e.target.value)} />
        <TextInput label="Kategori" value={v.category || ""} onChange={(e) => set("category", e.target.value)} placeholder="Fonksiyonel Parça" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TextInput label="Başlık TR (üzerine yazar, opsiyonel)" value={v.title_tr || ""} onChange={(e) => set("title_tr", e.target.value)} />
        <TextInput label="Başlık EN" value={v.title_en || ""} onChange={(e) => set("title_en", e.target.value)} />
      </div>

      <div>
        <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500 mb-2 block">Görsel</span>
        <div className="flex items-start gap-4">
          <div className="w-32 h-32 border border-white/10 bg-[#050505] grid place-items-center overflow-hidden">
            {preview ? <img src={preview} alt="" className="w-full h-full object-cover" /> : <span className="text-[10px] font-mono text-zinc-600">Yok</span>}
          </div>
          <div className="flex-1 space-y-3">
            <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid="portfolio-img-input" />
            <button type="button" onClick={() => fileRef.current?.click()} disabled={uploading} className="inline-flex items-center gap-2 border border-white/20 hover:border-[#FF4F00]/60 hover:bg-white/5 text-white font-mono uppercase tracking-wider text-[10px] px-4 py-2.5">
              {uploading ? <><Loader2 className="w-3.5 h-3.5 animate-spin" /> Yükleniyor…</> : <><UploadCloud className="w-3.5 h-3.5" /> Görsel Yükle</>}
            </button>
            <TextInput label="veya URL" value={v.image || ""} onChange={(e) => { set("image", e.target.value); set("storage_path", null); }} placeholder="https://…" />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TextInput label="Sıra" type="number" value={v.order ?? 0} onChange={(e) => set("order", parseInt(e.target.value) || 0)} />
        <div className="flex items-end"><Toggle checked={!!v.active} onChange={(x) => set("active", x)} label={v.active ? "Aktif" : "Pasif"} /></div>
      </div>
    </div>
  );
}
